import { Box } from "@dealer-center/core-components";
import { useNavigate, useParams } from "react-router-dom";
import { SECTIONS, type SectionKey } from "./hashConfig";
import { SectionGroup } from "./SectionGroup";
import { SECTION_CONFIG, isMasterDetail } from "./sectionConfig";

const SECTION_KEYS = Object.values(SECTIONS) as SectionKey[];
const MASTER_DETAIL_KEYS = SECTION_KEYS.filter(k =>
  isMasterDetail(SECTION_CONFIG[k])
);
const SINGLE_KEYS = SECTION_KEYS.filter(
  k => !isMasterDetail(SECTION_CONFIG[k])
);

export const DemoNav = () => {
  const { asAccount, asUser } = useParams<{
    asAccount?: string;
    asUser?: string;
  }>();
  const navigate = useNavigate();

  const handleSelect = (section: SectionKey) => {
    const base =
      asAccount && asUser
        ? `/cc/as/${asAccount}/${asUser}/leadManager`
        : `/cc/leadManager`;
    navigate(`${base}/${section}`);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3, p: 3 }}>
      <SectionGroup
        keys={MASTER_DETAIL_KEYS}
        title="Master–Detail"
        onSelect={handleSelect}
      />
      <SectionGroup
        keys={SINGLE_KEYS}
        title="Single Layout"
        onSelect={handleSelect}
      />
    </Box>
  );
};
